
export const isFetchingPrypoolProducts = (state) => {
    return state.prypool_products.request_types.fetching;
}

export const getAvailableProducts = (state) => {
    const products = state.prypool_products.products;
    if (Object.keys(products).length && products.available_products.length) {
        return products.available_products;
    }

    return null;
}

export const getBundleProducts = (state) => {
    const products = state.prypool_products.products;
    if (Object.keys(products).length && products.bundle_products.length) {
        return products.bundle_products;
    }

    return null;
}

export const getUnavailableProducts = (state) => {
    const products = state.prypool_products.products;
    if (Object.keys(products).length && products.unavailable_products.length) {
        return products.unavailable_products;
    }

    return null;
}

export const getUserSelectedProducts = (state) => {
    const selected_products = state.prypool_products.selected_products;
    if (Object.keys(selected_products).length) {
        return selected_products
    }

    return null;
}

export const getProductsForCheckout = (state) => {
    const selected_products = state.prypool_products.selected_products;
    let products_prices = [];
    Object.values(selected_products).forEach(product => {
        const is_available = isProductAvailable(product.metadata);
        if (is_available) {
            const price = getNonZeroPrice(product.prices)
            products_prices.push({ price: price.id, quantity: 1 });
        } else {
            const price = getZeroPrice(product.prices)
            products_prices.push({ price: price.id, quantity: 1 });
        }
    })

    return products_prices;
}


const isProductAvailable = (metadata) => {
    if (metadata.hasOwnProperty('is_available')) {
        return (metadata.is_available === "true")
    } else {
        return false;
    }
}

const getNonZeroPrice = (prices) => {
    return prices.filter(price => { return price.unit_amount > 0 })[0]
}

const getZeroPrice = (prices) => {
    return prices.filter(price => { return price.unit_amount === 0 })[0]
}


export const getDuplicatedProducts = (state, bundle) => {
    const selected_products = getUserSelectedProducts(state);
    if (selected_products && Object.keys(selected_products).length) {
        const bundle_circle_guids = bundle.metadata.bundle_circle_guids.split(',');
        const products = Object.values(selected_products).filter(product => { return bundle_circle_guids.includes(product.metadata.circle_guid) })
        return products;
    }
    return [];
}

export const checkIfProductIsInBundles = (state, product) => {
    const selected_products = getUserSelectedProducts(state);
    let is_included_in_bundles = false;
    if (selected_products && Object.keys(selected_products).length) {
        Object.values(selected_products).forEach(selected_product => {
            if (is_included_in_bundles) return;
            if (selected_product.metadata.is_bundle) {
                const bundle_circle_guids = selected_product.metadata.bundle_circle_guids.split(',');
                if (bundle_circle_guids.includes(product.metadata.circle_guid)) {
                    is_included_in_bundles = true;
                }
            }
        });
        return is_included_in_bundles;
    }
    return false;
}

export const getSharingBox = (state, boxId) => {
    const sharing_boxes = state.prypool_products.sharing_boxes;
    if (sharing_boxes.hasOwnProperty(boxId)) {
        return sharing_boxes[boxId];
    }
    return null;
}


export const isFetchingSessionId = (state) => {
    return state.prypool_products.fetching_session_id;
}

export const isFetchingRentalSession = (state) => {
    return state.prypool_products.fetching_rental_session;
}